<h1>{{ (taskArea.id ? 'task-area.edit' : 'task-area.create') | translate }}</h1>
<data-table>
	<data-row>
		<custom-input [label]="'task-area.name' | translate" [(value)]="taskArea.name" [required]="true" />
	</data-row>
	<data-row>
		<custom-input [label]="'task-area.color' | translate" [(value)]="taskArea.color" [required]="true" />
	</data-row>
</data-table>
<div class="row">
	<div class="col-6 offset-6">
		<submit-button #submitButton (click)="saveTaskArea()" [label]="'general.save' | translate" />
	</div>
</div>